import React, { FC } from 'react';
import { ReactComponent as PDFFile } from '../../../assets/ExportButtons/PDFFile.svg';

export const PDFFileIcon: FC = () => <PDFFile />;
